import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, reduxForm, formValueSelector, Field } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import { injectIntl, FormattedMessage } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Form, Button } from 'react-bootstrap';
// Loader
import Loader from '../Loader';
import CommonFormComponent from '../CommonField/CommonFormComponent';
import { getListBlockedDates } from '../../actions/Listing/getListBlockedDates';
import { getListingDataStep3 } from '../../actions/getListingDataStep3';
// Locale
import messages from '../../locale/jsonMessages';
import validate from './validate';
import { normalizePrice } from '../EditProfileForm/normalizePhone';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { withMutation } from '../../hoc/withGraphql';

import cs from '../commonStyle.css';
import s from './SaveCalendar.css';

class AvailableDates extends Component {

	constructor(props) {
		super(props);
		this.state = {
			dateRange: [],
			isLoading: false,
			isDisabled: false
		};
		this.submitForm = this.submitForm.bind(this);
	}

	componentDidMount() {
		const { formErrors } = this.props;
		this.setState({ isDisabled: formErrors?.hasOwnProperty('syncErrors') ? true : false });
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { start, end, formErrors } = nextProps;
		let dateRange = [], rangeStart, rangeEnd;

		if (start && !end) {
			rangeStart = new Date(start);
			dateRange.push(rangeStart);
		} else if (start && end) {
			rangeStart = new Date(start);
			rangeEnd = new Date(end);

			if (!moment(rangeStart).isSame(rangeEnd)) {
				dateRange.push(rangeStart);

				rangeStart = new Date(+rangeStart);

				while (rangeStart < end) {

					dateRange.push(rangeStart);
					var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
					rangeStart = new Date(newDate);
				}
			} else {
				dateRange.push(rangeStart);
			}
		}
		this.setState({ isDisabled: formErrors?.hasOwnProperty('syncErrors') ? true : false });
		this.setState({ dateRange });
	}


	async submitForm() {
		const { listId, resetCalendar, dispatch, mutate } = this.props;
		const { isSpecialPrice, start, end, selectedDays, getListBlockedDates, getListingDataStep3 } = this.props;
		const { dateRange, isLoading } = this.state;
		const { formatMessage } = this.props.intl;
		const { minDay, maxDay, houseRules, checkInEnd, checkInStart } = this.props;
		const { cancellationPolicy, maxDaysNotice, bookingNoticeTime } = this.props;
		const { basePrice, delivery, currency, isStartDate, isEndDate, monthlyDiscount, weeklyDiscount, securityDeposit } = this.props;
		const { removeBlockedDates, updateBlockedDates, setStateLoading } = this.props;

		let minDayValues, maxDayValues, checkInEndValue, checkInStartValue, isCancel,
			isMaxDays, isBooking, updatedAvailableDatesDays, dateRangeNew = [], rangeStart, rangeEnd;

		minDayValues = minDay != '' ? minDay : 0;
		maxDayValues = maxDay != '' ? maxDay : 0;
		checkInEndValue = checkInEnd != '' ? checkInEnd : 'flexible';
		checkInStartValue = checkInStart != '' ? checkInStart : 'flexible';
		isCancel = cancellationPolicy ? cancellationPolicy : '1';
		isMaxDays = maxDaysNotice ? maxDaysNotice : 'unavailable';
		isBooking = bookingNoticeTime ? bookingNoticeTime : 58;
		updatedAvailableDatesDays = dateRange;
		setStateLoading({ isBlocking: true })

		if (isStartDate && !isEndDate) {
			rangeStart = new Date(isStartDate);
			dateRangeNew.push(rangeStart);
		} else if (isStartDate && isEndDate) {
			rangeStart = new Date(isStartDate);
			rangeEnd = new Date(isEndDate);

			if (!moment(rangeStart).isSame(rangeEnd)) {
				dateRangeNew.push(rangeStart);

				rangeStart = new Date(+rangeStart);

				while (rangeStart < isEndDate) {

					dateRangeNew.push(rangeStart);
					var newDate = rangeStart.setDate(rangeStart.getDate() + 1);
					rangeStart = new Date(newDate);
				}
			} else {
				dateRangeNew.push(rangeStart);
			}
		}

		if (isSpecialPrice && (isNaN(isSpecialPrice) || (parseFloat(isSpecialPrice, 10) < 0.1))) {
			showToaster({ messageId: 'invalidSpecialPrice', toasterType: 'error' })
			setStateLoading({ isBlocking: false })
			return;
		}

		if (dateRangeNew?.length > 0) {

			dateRangeNew.forEach(async (item, index) => {
				let selectedIndex = updatedAvailableDatesDays.findIndex(selectedDay =>
					moment(selectedDay).isSame(item)
				);

				if (selectedIndex < 0) {
					updatedAvailableDatesDays.push(item);
				}
			});


			if (isSpecialPrice && isSpecialPrice > 0) {

				const { data } = await updateBlockedDates({
					variables: {
						listId,
						blockedDates: updatedAvailableDatesDays,
						calendarStatus: 'available',
						isSpecialPrice: parseFloat(isSpecialPrice)
					}
				});

				if (data?.UpdateBlockedDates?.status == '400') {
					showToaster({ messageId: 'updateBlockedDates', toasterType: 'error' })
				}

			} else {
				const { data } = await removeBlockedDates({
					variables: {
						listId,
						blockedDates: updatedAvailableDatesDays,
					}
				});
				if (data?.removeBlockedDates?.status == '200') {

				} else if (data?.removeBlockedDates?.status == '400') {
					showToaster({ messageId: 'removeBlockedDates', toasterType: 'error' })
				} else {
					setStateLoading({ isBlocking: false })
				}
			}
			await change("blockedDates", updatedAvailableDatesDays);
			await getListingDataStep3(listId);
			await getListBlockedDates(
				listId,
				minDayValues,
				maxDayValues,
				checkInEndValue,
				checkInStartValue,
				houseRules,
				isCancel,
				isMaxDays,
				isBooking,
				basePrice,
				delivery,
				currency,
				monthlyDiscount,
				weeklyDiscount,
				securityDeposit
			);
			await getListingDataStep3(listId);
			await resetCalendar();
			window.scroll({ top: 0 });
			setStateLoading({ isBlocking: false })
		}
	}


	render() {
		const { error, handleSubmit, submitting, start, end, isStartDate, isBlocking, isSaving, resetCalendar } = this.props;
		const { formatMessage } = this.props.intl;
		const { isDisabled } = this.state;

		return (
			<div>
				{
					(start || isStartDate) && <span>
						<Form onSubmit={handleSubmit(this.submitForm)}>
							{error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
							<div className="oneColumnGrid">
								<Field
									name="isSpecialPrice"
									type="text"
									component={CommonFormComponent}
									placeholder={formatMessage(messages.basePriceLabel)}
									inputClass='commonInputField'
									labelText={formatMessage(messages.sessionPrice)}
									normalize={normalizePrice}
								/>
								<div className='doubleBtnFlexEnd'>
									<Button
										disabled={isSaving || isBlocking}
										className={cs.btnPrimaryBorder}
										onClick={() => { resetCalendar() }}
									>
										<FormattedMessage {...messages.deSelect} />
									</Button>
									<Loader
										type={"button"}
										buttonType={"button"}
										show={isBlocking}
										className={cx(cs.btnPrimary, 'loaderButtonFlex')}
										disabled={submitting || isSaving || isDisabled}
										label={formatMessage(messages.save)}
										containerClass={s.loaderContainer}
										handleClick={this.submitForm}
									/>
								</div>
							</div>
						</Form>
					</span>
				}
			</div>
		);
	}
}

AvailableDates = reduxForm({
	form: 'CalendarPrice', // a unique name for this form
	validate,
})(AvailableDates);

const selector = formValueSelector('CalendarPrice');

const mapState = (state) => ({
	isSpecialPrice: selector(state, 'isSpecialPrice'),
	formErrors: state.form.CalendarPrice,
});

const mapDispatch = {
	change,
	getListBlockedDates,
	getListingDataStep3
};

export default compose(
	injectIntl,
	withStyles(cs, s),
	connect(mapState, mapDispatch),
	withMutation(gql`
    mutation (
      $listId: Int!, 
      $blockedDates: [String],
      $calendarStatus: String,
      $isSpecialPrice: Float
    ) {
          UpdateBlockedDates (
            listId: $listId, 
            blockedDates: $blockedDates,
            calendarStatus: $calendarStatus,
            isSpecialPrice: $isSpecialPrice
        ) {
          status
        }
        }
  `, {
		name: 'updateBlockedDates'
	}),
	withMutation(gql`
      mutation removeBlockedDates(
      $listId: Int!,
      $blockedDates: [String],
      ){
        removeBlockedDates(
          listId: $listId, 
          blockedDates: $blockedDates,
          ) {
              status
              errorMessage
          }
      }
  `, {
		name: 'removeBlockedDates'
	}),
)(AvailableDates);
